import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { ConfirmationDialog } from 'components';

/* Confirm unsubscribe from a subscription. */
const UnsubscribeConfirm = ({
  subscription,
  onCancel,
  onConfirm,
  ...props
}) => {
  const message = (
    <span>
      {`Once you unsubscribe, you will no longer have access to `}
      <span className="noTranslate">{subscription?.sharer.namePossessed}</span>
      {` notes.`}
    </span>
  );
  return (
    <ConfirmationDialog
      cancel={{
        label: 'Never Mind',
        action: onCancel,
      }}
      confirm={{
        label: 'Unsubscribe',
        action: onConfirm,
      }}
      id={'confirmUnsubscribeDialog'}
      isOpen={Boolean(subscription)}
      labelledById="unsubscribe-confirmation"
      message={message}
      title="Are you sure you want to proceed?"
      titleComponent="h4"
      {...props}
    />
  );
};

UnsubscribeConfirm.propTypes = {
  subscription: PropTypes.object,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default memo(UnsubscribeConfirm);
